module.exports = __webpack_public_path__ + "a6e117e9c6bb0421d210203ded9dccc3.svg";